import { render, staticRenderFns } from "./PageOne.vue?vue&type=template&id=4a8f5e4a&scoped=true&"
import script from "./PageOne.vue?vue&type=script&lang=js&"
export * from "./PageOne.vue?vue&type=script&lang=js&"
import style0 from "./PageOne.vue?vue&type=style&index=0&id=4a8f5e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f5e4a",
  null
  
)

export default component.exports